/** @format */

import React, { Component } from "react";

import people_one from "../../assets/images/How-Teck-Lim.webp";
import people_five from "../../assets/images/Jermy tan.webp";
import people_seven from "../../assets/images/SAM PHOEN.webp";
import dave from "../../assets/images/dave.webp";
import joyce_ang from "../../assets/images/joyce_ang.webp";

import "./peopleStyles.css";

class People extends Component {
  render() {
    return (
      <div>
        <div id="team" className="clearfix dt_row our-people-section">
          <div className="container">
            <div className="row">
              <div id="dt_column_29" className="dt_column col-sm-12">
                <div id="dt_row_30153717827719" className="row dt_row">
                  <div id="dt_column_31" className="dt_column col-sm-12">
                    <div
                      id="dt-section-head-32"
                      className="dt-section-head center  size-small"
                    >
                      <div className="dt-section-container">
                        <h2 className="section-main-title section-heading-krypton ">
                          Our People
                        </h2>
                        <hr></hr>
                      </div>
                      <p className="descriptionText">
                        With extensive experience in investment banking, fund
                        management and private equity, coupled with strong
                        credit and client relationships built over years of
                        advisory services, 33 Capital Group has set its sights
                        on becoming Southeast Asia’s leading financial services
                        business complete with corporate advisory, fund
                        management and principal investment arms.
                      </p>
                      <br />
                      <br />
                    </div>
                  </div>
                </div>
                <div id="dt_row_33153717827738" className="row dt_row">
                  <div id="dt_column_34" className="dt_column col-sm-12">
                    <div id="team" className="profile_team">
                      <div className="row">
                        <div
                          id="module_dt_team35"
                          className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12"
                        >
                          <div
                            className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade"
                            data-uk-scrollspy="{cls:'uk-animation-fade', delay:600}"
                          >
                            <figure>
                              <div className="top-image">
                                <img
                                  src={people_one}
                                  className="img-responsive people_img"
                                  alt=""
                                />
                              </div>
                              <figcaption>
                                <h3>
                                  <span className="profile-heading">
                                    How Teck Lim
                                  </span>
                                </h3>
                                <span className="profile-subheading">
                                  Senior Advisor
                                </span>
                                <p>
                                  Chairman, Heliconia Capital (Temasek Group)
                                </p>
                                <ul className="profile-scocial">
                                  <li>
                                    <a
                                      href="http://www.heliconiacapital.com/BoardofDirectors.aspx"
                                      className="teamlink"
                                      title="linkedin"
                                    >
                                      <i className="fab fa-linkedin"></i>
                                    </a>
                                  </li>
                                </ul>
                                <div className="figcap"></div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        {/* <div
                          id="module_dt_team39"
                          className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12"
                        >
                          <div
                            className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade"
                            data-uk-scrollspy="{cls:'uk-animation-fade', delay:1800}"
                          >
                            <figure>
                              <div className="top-image">
                                <img src={people_eight} alt="" />
                              </div>
                              <figcaption>
                                <h3>
                                  <span className="profile-heading">
                                    Cynthia Siantar
                                  </span>
                                </h3>
                                <span className="profile-subheading">
                                  Investment Director
                                </span>
                                <p></p>
                                <ul className="profile-scocial">
                                  <li>
                                    <a
                                      href="https://www.linkedin.com/in/cynthiasiantar/"
                                      className="teamlink"
                                      title="linkedin"
                                    >
                                      <i className="fab fa-linkedin"></i>
                                    </a>
                                  </li>
                                </ul>
                                <div className="figcap"></div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div
                          id="module_dt_team36"
                          className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12"
                        >
                          <div
                            className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade"
                            data-uk-scrollspy="{cls:'uk-animation-fade', delay:900}"
                          >
                            <figure>
                              <div className="top-image">
                                <img
                                  src={people_four}
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <figcaption>
                                <h3>
                                  <span className="profile-heading">
                                    ALAN CHUA
                                  </span>
                                </h3>
                                <span className="profile-subheading">
                                  Venture Partner
                                </span>
                                <p></p>
                                <ul className="profile-scocial">
                                  <li>
                                    <a
                                      href="https://sg.linkedin.com/"
                                      className="teamlink"
                                      title="linkedin"
                                    >
                                      <i className="fab fa-linkedin"></i>
                                    </a>
                                  </li>
                                </ul>
                                <div className="figcap"></div>
                              </figcaption>
                            </figure>
                          </div>
                        </div> */}
                        <div
                          id="module_dt_team39"
                          className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12"
                        >
                          <div
                            className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade"
                            data-uk-scrollspy="{cls:'uk-animation-fade', delay:900}"
                          >
                            <figure>
                              <div className="top-image">
                                <img
                                  src={joyce_ang}
                                  className="img-responsive people_img"
                                  alt=""
                                />
                              </div>
                              <figcaption>
                                <h3>
                                  <span className="profile-heading">
                                    Joyce Ang
                                  </span>
                                </h3>
                                <span className="profile-subheading">
                                  Managing Partner
                                </span>
                                {/* <p>
                                  Ex-Director, Morgan Stanley, Nomura &amp;
                                  Credit Suisse
                                </p> */}
                                <ul className="profile-scocial">
                                  <li>
                                    <a
                                      href="https://www.linkedin.com/in/joyce-a-1a8507161/"
                                      className="teamlink"
                                      title="linkedin"
                                    >
                                      <i className="fab fa-linkedin"></i>
                                    </a>
                                  </li>
                                </ul>
                                <div className="figcap"></div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div
                          id="module_dt_team36"
                          className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12"
                        >
                          <div
                            className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade"
                            data-uk-scrollspy="{cls:'uk-animation-fade', delay:900}"
                          >
                            <figure>
                              <div className="top-image">
                                <img
                                  src={dave}
                                  className="img-responsive people_img"
                                  alt=""
                                />
                              </div>
                              <figcaption>
                                <h3>
                                  <span className="profile-heading">
                                    David Z Wang
                                  </span>
                                </h3>
                                <span className="profile-subheading">
                                  Venture Partner
                                </span>
                                <p>
                                  Ex-Director, Morgan Stanley, Nomura &amp;
                                  Credit Suisse
                                </p>
                                <ul className="profile-scocial">
                                  <li>
                                    <a
                                      href="https://sg.linkedin.com/in/dzwgroup"
                                      className="teamlink"
                                      title="linkedin"
                                    >
                                      <i className="fab fa-linkedin"></i>
                                    </a>
                                  </li>
                                </ul>
                                <div className="figcap"></div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                        <div
                          id="module_dt_team38"
                          className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12"
                        >
                          <div
                            className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade"
                            data-uk-scrollspy="{cls:'uk-animation-fade', delay:1500}"
                          >
                            <figure>
                              <div className="top-image">
                                <img
                                  src={people_five}
                                  className="img-responsive people_img"
                                  alt=""
                                />
                              </div>
                              <figcaption>
                                <h3>
                                  <span className="profile-heading">
                                    Jeremy Tan
                                  </span>
                                </h3>
                                <span className="profile-subheading">
                                  Venture Partner
                                </span>
                                <p>
                                  Director, Jia Shing Enterprise &amp; COO JL
                                  Capital (Hedge Fund)
                                </p>
                                <ul className="profile-scocial">
                                  <li>
                                    <a
                                      href="https://sg.linkedin.com/in/jeremy-tan-a5952680"
                                      className="teamlink"
                                      title="linkedin"
                                    >
                                      <i className="fab fa-linkedin"></i>
                                    </a>
                                  </li>
                                </ul>
                                <div className="figcap"></div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        {/* <div id="module_dt_team37" className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12">
                            <div className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade" data-uk-scrollspy="{cls:'uk-animation-fade', delay:1200}">
                              <figure>
                                <div className="top-image">
                                  <img src={people_six} className="img-responsive" alt=""/>
                                </div>
                                <figcaption>
                                  <h3>
                                    <span className="profile-heading">JING XI LIM</span>
                                  </h3>
                                  <span className="profile-subheading">Venture Partner</span>
                                  <p>Ex-Analyst, Temasek, Barclays &amp; Prime Minister’s Office</p>
                                  <ul className="profile-scocial">
                                    <li>
                                      <a href="https://www.linkedin.com/in/limjingxi" className="teamlink" title="linkedin">
                                        <i className="fab fa-linkedin"></i>
                                      </a>
                                    </li>
                                  </ul>
                                  <div className="figcap"></div>
                                </figcaption>
                              </figure>
                            </div>
                          </div> */}
                        {/* <div
                          id="module_dt_team38"
                          className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12"
                        >
                          <div
                            className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade"
                            data-uk-scrollspy="{cls:'uk-animation-fade', delay:1500}"
                          >
                            <figure>
                              <div className="top-image">
                                <img
                                  src={people_five}
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <figcaption>
                                <h3>
                                  <span className="profile-heading">
                                    Jeremy Tan
                                  </span>
                                </h3>
                                <span className="profile-subheading">
                                  Venture Partner
                                </span>
                                <p>
                                  Director, Jia Shing Enterprise &amp; COO JL
                                  Capital (Hedge Fund)
                                </p>
                                <ul className="profile-scocial">
                                  <li>
                                    <a
                                      href="https://sg.linkedin.com/in/jeremy-tan-a5952680"
                                      className="teamlink"
                                      title="linkedin"
                                    >
                                      <i className="fab fa-linkedin"></i>
                                    </a>
                                  </li>
                                </ul>
                                <div className="figcap"></div>
                              </figcaption>
                            </figure>
                          </div>
                        </div> */}

                        {/* <div
                          id="module_dt_team39"
                          className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12"
                        >
                          <div
                            className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade"
                            data-uk-scrollspy="{cls:'uk-animation-fade', delay:900}"
                          >
                            <figure>
                              <div className="top-image">
                                <img
                                  src={krishanRattan}
                                  alt=""
                                  className="img-responsive people_img"
                                />
                              </div>
                              <figcaption>
                                <h3>
                                  <span className="profile-heading">
                                    Krishan Rattan
                                  </span>
                                </h3>
                                <span className="profile-subheading">
                                  Venture Partner
                                </span>
                                {/* <p>
                                  ex Director GIC, ex ANZ Head of Global
                                  Markets, China
                                </p> */}
                        {/* <ul className="profile-scocial">
                                  <li>
                                    <a
                                      href="https://sg.linkedin.com/in/sam-phoen-42805217"
                                      className="teamlink"
                                      title="linkedin"
                                    >
                                      <i className="fab fa-linkedin"></i>
                                    </a>
                                  </li>
                                </ul> */}
                        {/* <div className="figcap"></div>
                              </figcaption>
                            </figure>
                          </div>
                        </div> */}
                        {/* <div
                          id="module_dt_team39"
                          className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12"
                        >
                          <div
                            className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade"
                            data-uk-scrollspy="{cls:'uk-animation-fade', delay:1800}"
                          >
                            <figure>
                              <div className="top-image">
                                <img src={krishanRattan} alt="" />
                              </div>
                              <figcaption>
                                <h3>
                                  <span className="profile-heading">
                                    Krishan Rattan
                                  </span>
                                </h3>
                                <span className="profile-subheading">
                                  Krishan Rattan
                                </span>

                                <ul className="profile-scocial">
                                  <li>
                                    <a
                                      href="https://sg.linkedin.com/in/sam-phoen-42805217"
                                      className="teamlink"
                                      title="linkedin"
                                    >
                                      <i className="fab fa-linkedin"></i>
                                    </a>
                                  </li>
                                </ul>
                                <div className="figcap"></div>
                              </figcaption>
                            </figure>
                          </div>
                        </div> */}

                        <div
                          id="module_dt_team39"
                          className="profile_team col-lg-3 col-md-4 col-sm-6 col-xs-12"
                        >
                          <div
                            className="profile uk-scrollspy-init-inview uk-scrollspy-inview uk-animation-fade"
                            data-uk-scrollspy="{cls:'uk-animation-fade', delay:1800}"
                          >
                            <figure>
                              <div className="top-image">
                                <img
                                  src={people_seven}
                                  alt=""
                                  className="img-responsive people_img"
                                />
                              </div>
                              <figcaption>
                                <h3>
                                  <span className="profile-heading">
                                    Sam Phoen
                                  </span>
                                </h3>
                                <span className="profile-subheading">
                                  Senior Advisor
                                </span>
                                <p>
                                  ex Director GIC, ex ANZ Head of Global
                                  Markets, China
                                </p>
                                <ul className="profile-scocial">
                                  <li>
                                    <a
                                      href="https://sg.linkedin.com/in/sam-phoen-42805217"
                                      className="teamlink"
                                      title="linkedin"
                                    >
                                      <i className="fab fa-linkedin"></i>
                                    </a>
                                  </li>
                                </ul>
                                <div className="figcap"></div>
                              </figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default People;



// WEBPACK FOOTER //
// ./src/components/People/index.js